import { apiClient } from '../client'

/**
 * Tickets API endpoints
 */
export const ticketsApi = {
  /**
   * Get tickets list
   */
  getList: async (params?: string): Promise<any> => {
    const url = params ? `/ticket/?${params}` : '/ticket/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get ticket by ID
   */
  getById: async (ticketId: string): Promise<any> => {
    const { data } = await apiClient.get(`/ticket/${ticketId}/`)
    return data
  },

  /**
   * Create ticket
   */
  create: async (payload: any): Promise<any> => {
    const { data } = await apiClient.post('/ticket/', payload)
    return data
  },

  /**
   * Update ticket
   */
  update: async (ticketId: string, payload: any): Promise<any> => {
    const { data } = await apiClient.patch(`/ticket/${ticketId}/`, payload)
    return data
  },

  /**
   * Close ticket
   */
  close: async (ticketId: string): Promise<any> => {
    const { data } = await apiClient.post(`/ticket/${ticketId}/close/`)
    return data
  },

  /**
   * Get ticket filter options
   */
  getFilterOptions: async (): Promise<any> => {
    const { data } = await apiClient.get('/ticket/filter/')
    return data
  },
}
